import { connect } from 'react-redux';
import { removeOverlay } from 'services/overlays';
import { trackOverlay } from 'services/insights';
import MessageOverlay from './view';

const mapDispatchToProps = dispatch => ({
  onDismiss: key => dispatch(removeOverlay(key)),
  trackDismiss: doc => dispatch(trackOverlay('dismiss', doc)),
});

export default connect(null, mapDispatchToProps)(MessageOverlay);
